module.exports = __webpack_public_path__ + "img/marker.9408e08f.png";